import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import {
  MDBCarousel,
  MDBCarouselCaption,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBView,
} from "mdbreact";
import carouselItems from "../Helpers/carousel-data";

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let carousel = carouselItems.items.map((item, key) => {
      return (
        <MDBCarouselItem itemId={item.id} key={key}>
          <MDBView>
            <img
              style={{ objectFit: "cover", width: "100%", height: "250px" }}
              src={item.img}
              alt=""
              className="d-block w-100"
            />
          </MDBView>
          <MDBCarouselCaption>
            <h3 className="h3-responsive">{item.caption}</h3>
            <p>{item.description}</p>
          </MDBCarouselCaption>
        </MDBCarouselItem>
      );
    });

    return (
      <div style={{ padding: "10px" }}>
        <MDBCarousel
          activeItem={1}
          length={carouselItems.items.length}
          showControls={true}
          showIndicators={true}
          className="z-depth-1"
        >
          <MDBCarouselInner>{carousel}</MDBCarouselInner>
        </MDBCarousel>
      </div>
    );
  }
}

export default Slider;
